import { BasicTooltip, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
export default function ExportStatementsModal(props) {
  const classes = useStyles();
  const _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$isIconTrigger = props.isIconTrigger,
    isIconTrigger = _props$isIconTrigger === void 0 ? false : _props$isIconTrigger,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? undefined : _props$trigger;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    variant: "action",
    'custom-attribute': '317-ExportStatementsModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), t('general.export'));
  const iconTrigger = /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('general.export'),
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '318-ExportStatementsModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  })));
  const getTrigger = () => {
    if (trigger) return trigger;
    if (isIconTrigger) return iconTrigger;
    return defaultTrigger;
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: getTrigger(),
    title: t('residencies_page.export_statements'),
    noFooter: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.modalContentLoader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.spinner
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "loader"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('residencies_page.preparing_pdf_statements')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light"
  }, t('residencies_page.archive_ready'))));
}
ExportStatementsModal.propTypes = {
  disabled: PropTypes.bool,
  isIconTrigger: PropTypes.bool,
  trigger: PropTypes.node
};